import React from "react";
import { useNavigate } from "react-router-dom";

const Options = ({ SVG, text, route, closeTray }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        navigate(route);
        if (closeTray) closeTray();
      }}
      style={{ padding: "13px 16px", gap: "0.5rem", borderRadius: "8px" }}
      className="d-flex justify-content-between w-100 align-items-center bg-white"
    >
      <div>
        <SVG />
      </div>
      <div
        className="w-100 textColor"
        style={{
          fontFamily: "Inter",
          fontSize: "1.125rem",
          lineHeight: "100%",
          letterSpacing: "0%",
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default Options;
